module.exports = __webpack_public_path__ + "static/media/unite.95d778b9.svg";